import { Link } from "react-router-dom";
import styled from "styled-components";
import { TrendingUp } from "lucide-react";
import { Container } from "../layout/Container";
import { cPath } from "../../constants";

const Section = styled.section`
  padding: 1.5rem 0;
`;

const Bar = styled.div`
  background: hsl(${({ theme }) => theme.colors.card});
  border-radius: ${({ theme }) => theme.radius.xl};
  border: 1px solid hsl(${({ theme }) => theme.colors.border});
  padding: 1rem 1.5rem;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.75rem;
`;

const Label = styled.span`
  font-size: 0.875rem;
  font-weight: 600;
  color: hsl(${({ theme }) => theme.colors.foreground});
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
`;

const TermLink = styled(Link)`
  font-size: 0.875rem;
  color: hsl(${({ theme }) => theme.colors.primary});
  &:hover {
    text-decoration: underline;
  }
`;

const Muted = styled.span`
  font-size: 0.875rem;
  color: hsl(${({ theme }) => theme.colors.mutedForeground});
`;

export default function HomeTrendingSearches({ terms = [] }) {
  const list = Array.isArray(terms) ? terms : [];

  return (
    <Section>
      <Container>
        <Bar>
          <Label>
            <TrendingUp size={16} strokeWidth={2} color="hsl(43 80% 52%)" />
            Trending searches:
          </Label>
          {list.length === 0 ? (
            <Muted>No trending terms yet.</Muted>
          ) : (
            list.map((term) => (
              <TermLink
                key={term}
                to={`${cPath("search")}?q=${encodeURIComponent(String(term).split(" ")[0])}`}
              >
                {term}
              </TermLink>
            ))
          )}
        </Bar>
      </Container>
    </Section>
  );
}
